<template>
  <div id="introduction">
    <b-container fluid class="align-center p-0">
      <b-row align-v="center">
        <b-col>
          <h1 class="text-primary font-weight-bold mb-5">Introduction</h1>
          <div class="text-left">
            <p class="text-muted mx-0 intro">
              Miami-Dade County Public Schools (M-DCPS) is presenting voters with a referendum renewal that will appear on the November 8, 2022, election ballot.</p>
            <p class="text-muted mx-0 intro">
              These funds will allow for the continuation of improvements made to the compensation of teachers and instructional personnel as a result of the 2018 referendum, approved by the voters and set to expire June 30, 2023, an issue critical to the recruiting and retaining outstanding instructional personnel.
</p>
<p class="text-muted mx-0 intro">
The funds will also continue to be used to improve student safety and school security as it has been since 2018. 
All public schools, both Miami-Dade County Public Schools and charter schools, will share the revenue, proportionate to the school's student enrollment.  
</p>
<p class="text-muted mx-0 intro">
Why does M-DCPS need to renew the referendum and increase to 1 mill?
</p>
<p class="text-muted mx-0 intro">
  The funds from the original .75 mill referendum that voters approved in 2018 are set to expire. Improvements to compensation over the past four years would be lost if the renewal does not pass.  Teachers and instructional personnel compensation could be cut drastically. As a result, and many outstanding teachers would likely leave the district. The school district would also have to reallocate funding to provide police protection at every school.  It is necessary to increase to 1 mil as a result of changes to State statue, which now require revenues raised by any referendum to be shared with charter schools. The .25 mil increase thus allows M-DCPS to maintain its existing improvements to institutional compensation and school security.  The use of all referendum funds will continue to be monitored by an independent citizen’s advisory committee. </p>
            <!-- <b-button class="rounded-0 text-white border-0 px-4 py-2 bg-purple right" href="https://api.dadeschools.net/WMSFiles/264/docs/M1149%20-%20Attachment%20-%20Strategic%20Plan%20Stakeholder%20Survey%20Results%20and%20Focus%20Group%20Synthesis.pdf">Read More</b-button> -->
          </div>
        </b-col>
        <b-col class="d-none d-xl-block p-0 cf">
          <b-carousel
          :interval="5000"
          fade
           class="seal">
           <b-carousel-slide
            :img-src="require('@/assets/img/Image_2Placeholder.png')"
            alt="Female Police officer holding ice cream smiling with child"
            ></b-carousel-slide>
            <b-carousel-slide
            :img-src="require('@/assets/img/Women-officer-banner-1.png')"
            alt="Female Officer smiling with police car behind her"
            ></b-carousel-slide>
            <b-carousel-slide
            :img-src="require('@/assets/img/police-office-banner-2.png')"
            alt="Female Officer speaking to children in class"
            ></b-carousel-slide>
            <b-carousel-slide
            :img-src="require('@/assets/img/women-office-with-kid-banner-3.png')"
            alt="Fmiling female officer showing paper to child"
            ></b-carousel-slide>

            </b-carousel>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Introduction",
};
</script>
<style>
.intropic {
  min-width: 1vm;
}
.intro {
  font-size: 18px;
}
.right {
  float: right;
  width: 300px;
  border: 3px solid #73ad21;
  padding: 10px;
}

@media screen and (max-width: 800px) {
  .intro {
    font-size: 18px;
  }
}
</style>
